import { render, staticRenderFns } from "./CreateTicketAdmin.vue?vue&type=template&id=5f96b206&"
import script from "./CreateTicketAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateTicketAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports